export default {
  title: 'KeyPalがサポートするブロックチェーン一覧（1000+）',
  getKeypal: 'KeyPalを入手',
  comingSoon: '近日公開',
  list: {
    title: 'ブロックチェーン',
    detail: '詳細',
    urlName: 'リンク',
  },
}
